import { createGlobalStyle } from 'styled-components';

const GlobalStyles = createGlobalStyle`
body {
    text-align: center;
}

input:-webkit-autofill {
    -webkit-box-shadow: 0 0 0 100px #f5f5f5 inset !important;
    -webkit-text-fill-color: #000 !important;
    border-radius: 8px!important;
    background-color: var(--mui-palette-FilledInput-bg) !important;
    font-size: 1rem;
    color: var(--mui-palette-text-primary);
    font-family: 'Roboto', sans-serif;
}

.MuiInputLabel-asterisk,
.MuiFormLabel-asterisk {
    color: red !important;
}
`;

export default GlobalStyles;
